// src/redux/reducers/cityReducer.js
import {
    FETCH_CITY_FAILURE,
    FETCH_CITY_REQUEST,
    FETCH_CITY_SUCCESS, 
    SET_SELECTED_CITY,
    CLEAR_CITY_LIST
  } from '../types'; 
  
  const initialState = {
    loading: false,
    cityList: [],
    selectedcityId: null, 
    error: null,
  };
  
  const cityReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_CITY_REQUEST:
        return { ...state, loading: true };
      case FETCH_CITY_SUCCESS:
        return { ...state, loading: false, cityList: action.payload };
      case FETCH_CITY_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case SET_SELECTED_CITY:
        return { ...state, selectedcityId: action.payload };
        case CLEAR_CITY_LIST:
          return { ...state, cityList: [] }; // Clear the city list
      default:
        return state;
    }
  };
  
  export default cityReducer;
  